import { Person, PersonData } from "@/sources/kicker-amateur/types";
import IconDefaultUser from "@/assets/user/default.svg";
import Image from "./Image";
// TODO:Timo TODO:Matthias use svg (right now its not working, IconDefaultUser.src is empty)

interface PersonImageType {
  person?: Person | PersonData,
  className?: string,
  imageClassName?: string,
  noCache?:boolean
}


export default function PersonImage(
  {
    person,
    className,
    imageClassName,
    noCache,
    ...attributes
  }
  :
  PersonImageType) {
  const aspectImage = person?.MediaServiceImages?.find(Boolean)
  return (
    <div className={`relative aspect-person ${className || ""}`}>
      <Image
        {...attributes}
        className={`rounded-full object-cover w-full aspect-person h-auto ${imageClassName}`}
        width="100"
        height="100"
        src={aspectImage?.AbsoluteUrl ?? `/api/image/person/${person?.Id}${noCache ? "?no_cache=true" : ""}`}
        alt={`Profilbild: ${person?.FirstName} ${person?.LastName}`}
        fallback={IconDefaultUser.src}
      />
    </div>
  )
}
